export default "__VITE_ASSET__tkoEpPBB__"